var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Axios from 'axios';
import Qs from 'qs';
import dayjs from 'dayjs';
import { getInfo } from './utils';
import clientInit from './client/clientInit';
var buildKfIHeader = function (serverInfo, appInfo) {
    var parseClientInfo = function (info) {
        if (!info) {
            return {};
        }
        if (typeof info === 'string') {
            try {
                var parsedInfo = JSON.parse(info);
                return Object.prototype.toString.call(parsedInfo) === '[object Object]'
                    ? parsedInfo
                    : {};
            }
            catch (error) {
                return {};
            }
        }
        if (Object.prototype.toString.call(info) === '[object Object]') {
            return info;
        }
        return {};
    };
    var parsedServerInfo = parseClientInfo(serverInfo);
    // 如果serverInfo是空对象，则直接返回服务端下发的serverInfo，否则合并appInfo和serverInfo
    if (!Object.keys(parsedServerInfo).length) {
        return serverInfo ? encodeURIComponent(serverInfo) : '';
    }
    var mergedInfo = __assign(__assign({}, parseClientInfo(appInfo)), parsedServerInfo);
    return Object.keys(mergedInfo).length ? encodeURIComponent(JSON.stringify(mergedInfo)) : '';
};
/** @use Axios 请求config处理 */
var axiosConfig = function (config) {
    var tempConfig = config;
    var _a = getInfo(), u = _a.u, t = _a.t, i = _a.i, v = _a.v, flag = _a.flag, runtime = _a.runtime, token = _a.token;
    if (tempConfig.method === 'get') {
        tempConfig.params = __assign(__assign({}, tempConfig.params), { _: dayjs().valueOf() });
    }
    var appInfo = clientInit.getAppInfo();
    tempConfig.headers = __assign(__assign({}, tempConfig.headers), { 'Kf-U': u || '', 'Kf-T': t || '', 'Kf-I': buildKfIHeader(i, appInfo), 'Kf-V': v || '', 'Kf-Flag': flag || '', 'Kf-Runtime': runtime || '', 'Kf-Token': token || '' });
    return tempConfig;
};
function request(params) {
    var kfInstance = Axios.create({
        headers: {
            'x-requested-with': 'XMLHttpRequest',
            'x-prevent-preflight': true
        },
        baseURL: '/',
        withCredentials: true
    });
    kfInstance.interceptors.request.use(function (config) {
        var tempConfig = axiosConfig(config);
        return tempConfig;
    }, function (err) {
        return Promise.reject(err.toString());
    });
    kfInstance.interceptors.response.use(function (res) {
        var data = res.data;
        if (!res.data) {
            alert('数据返回失败');
            return Promise.reject(res);
        }
        switch (data.c) {
            case 0:
                return Promise.resolve(res);
            case 200:
                return Promise.resolve(res);
            default:
                return Promise.reject(res);
        }
    }, function (err) {
        var _a, _b;
        if (err.message) {
            if (err.message === 'Network Error') {
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject('当前网络不给力，请检查您的网络');
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject("\u8BF7\u6C42\u9519\u8BEF ".concat((_a = err.response) === null || _a === void 0 ? void 0 : _a.status, "\uFF1A").concat((_b = err.response) === null || _b === void 0 ? void 0 : _b.statusText));
        }
        return Promise.reject(err.toString());
    });
    return kfInstance(params);
}
export var getWithoutHeader = function (url, params) {
    return request({
        method: 'GET',
        url: url,
        params: params,
        transformRequest: [
            function (data, headers) {
                delete headers['x-requested-with'];
                return data;
            }
        ]
    });
};
export var get = function (url, params, options) {
    return request(__assign({ method: 'GET', url: url, params: params }, options));
};
export var post = function (url, data) {
    return request({
        method: 'POST',
        url: url,
        data: Qs.stringify(data)
    });
};
export var upload = function (url, data, options) {
    return request(__assign({ method: 'POST', url: url, data: data }, options));
};
